var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "settle-claim"
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("保单号")) + " ：" + _vm._s(_vm.policyInfo.policyNo))]), _c("div", [_vm._v(_vm._s(_vm.$t("产品名称")) + "：" + _vm._s(_vm.policyInfo.insuranceName))]), _c("div", [_vm._v(_vm._s(_vm.$t("生效日期")) + "：" + _vm._s(_vm.policyInfo.startAt))]), _c("div", [_vm._v(_vm._s(_vm.$t("终止日期")) + "：" + _vm._s(_vm.policyInfo.endAt))]), _c("div", [_vm._v(_vm._s(_vm.$t("保单状态")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.policyStatus)))]), _c("div", [_vm._v(_vm._s(_vm.$t("承保单位")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.unitName)))]), _c("div", [_vm._v(_vm._s(_vm.$t("机构全称")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.agencyName)))]), _c("div", [_vm._v(_vm._s(_vm.$t("保单归属")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.customerName)))])]), _c("div", {
    staticClass: "content-box"
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-col": {
        span: 24
      },
      "wrapper-col": {
        span: 24
      },
      rules: _vm.rules
    }
  }, _vm._l(_vm.formItems, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "title_name"
    }, [_vm._v(_vm._s(_vm.$t(item.formName)))]), _vm._l(item.form, function (item2, controlIndex) {
      return _c("div", {
        key: controlIndex
      }, [item2.controlType === "control" && _vm.showControl[item2.control.mark] ? _c("div", [_c("formControlItem", {
        ref: `control${item2.control.mark}`,
        refInFor: true,
        attrs: {
          formData: _vm.formData,
          controlItem: item2.control,
          associationInfo: _vm.associationInfo
        },
        on: {
          valueChange: _vm.valueChangeValidate,
          changeControlShow: _vm.changeControlShow
        }
      })], 1) : item2.controlType === "controlGroup" && _vm.showControl[item2.mark] ? _c("div", [_c("h4", [_vm._v(_vm._s(item2.controlName))]), _vm._l(item2.control, function (subControl, subControlIndex) {
        return _c("div", {
          key: subControlIndex
        }, [_c("formControlItem", {
          ref: `control${subControl.mark}`,
          refInFor: true,
          attrs: {
            formData: _vm.formData,
            controlItem: subControl,
            associationInfo: _vm.associationInfo
          },
          on: {
            valueChange: _vm.valueChangeValidate,
            changeControlShow: _vm.changeControlShow
          }
        })], 1);
      })], 2) : _vm._e()]);
    })], 2);
  }), 0), _vm.actionButton.length != 0 ? _c("div", {
    staticClass: "btn-box"
  }, _vm._l(_vm.actionButton, function (item, index) {
    return _c("a-button", {
      key: index,
      staticClass: "marginL15",
      attrs: {
        type: item.color,
        loading: _vm.loading
      },
      on: {
        click: function ($event) {
          return _vm.onSubmit(item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1) : _vm._e(), _vm.showSendEmail ? _c("email-send-model", {
    attrs: {
      notifyData: _vm.notifyData,
      visible: _vm.showSendEmail
    },
    on: {
      closeModel: _vm.closeModel,
      "update:visible": function ($event) {
        _vm.showSendEmail = $event;
      },
      cancel: function ($event) {
        _vm.showSendEmail = false;
      }
    }
  }) : _vm._e(), _vm.showPreviewFile ? _c("previewFileModel", {
    attrs: {
      previewVisible: _vm.showPreviewFile,
      fileList: _vm.previewFileList
    },
    on: {
      cancel: _vm.restPreviewFile
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };